import { Api } from 'utils';

class PlanningService {
	
	static admin = {
		get: async (params?: any) => Api.createResponse('admin/planning',params),
		getRoutes: async (params?: any) => Api.createResponse('admin/planning/routes',params),
		save: async (params?: any) => Api.createResponse('admin/planning/save',params),
		download: async (params?: any) => Api.createResponse('admin/planning/download',params)
	}

}

export default PlanningService;